/* 
* Lib
* Domain: Christophernathaniel.co.uk
* MIT License Copyright (c) 2022 Christopher Nathaniel 
*
* Usage ----------------------------------------------
* Initialise Scroller with: scroller.init(state);
*/


import lib from '../lib/lib.js';

const scroller = {
    
    intersectionCallback: (entries) => {
        // Select all imgs and add class for the parallax
        document.querySelectorAll(".row").forEach((elem) => {
            // Get first child
            const elemFirstImg = elem.querySelector(".img-wrapper:first-child");
            elemFirstImg.classList.add("can-parallax-fast");
            // Get last child
            const elemLastImg = elem.querySelector(".img-wrapper:last-child");
            elemLastImg.classList.add("can-parallax-slow")
        });
        
        entries.forEach(entry => {
            entry.target.classList.add("js-intersection");
        
            if(entry.isIntersecting) {
                entry.target.classList.add("is-intersecting");
                entry.target.classList.add("has-intersected");

                window.addEventListener("scroll", scroller.render.bind(null, entry.target));

            } else {
                entry.target.classList.remove("is-intersecting");
            }
        
        });
    },
    render: (element = null) => {
        
        if(!element) {
           element = lib.qsa(".can-intersect")
        }

        if(Array.isArray(element)) {
            element.forEach(el => {
                effect(el);
            });
        } else {
            effect(element);
        }

        function effect(element) {

            let parallaxFast = element.querySelectorAll(".can-parallax-fast");
            let parallaxSlow = element.querySelectorAll(".can-parallax-slow");

            let boundingRect = (window.scrollY + element.getBoundingClientRect().top)
            let scrollCalc = window.scrollY - boundingRect;
            
            if(parallaxFast) {
                parallaxFast.forEach(elem => {
                    elem.style.transform = `translateY(-${scrollCalc * 0.5}px)`;
                });
            }
            
            if(parallaxSlow) {
                parallaxSlow.forEach(elem => {
                    elem.style.transform = `translateY(-${scrollCalc * 0.1}px)`;
                });
            }
        }
    },
    init: (state) => {
            
        lib.qsa(".can-intersect").forEach((elem) => {
            let options = {
                root: lib.body,
                rootMargin: "0px 0px 0px 0px",
                threshold: 0.2
            }
        
            let observer = new IntersectionObserver(scroller.intersectionCallback, options)
            observer.observe(elem);
        }) 
    }

}

export { scroller as default }